import React, {useState} from "react";

//Our parent component
const OTPInputGroup = (props) => {
    //state to store all input boxes    
    const [inputValues, setInputValues] = useState({
        input1: '',
        input2: '',
        input3: '',
        input4: ''
        // Add more input values here
    });

    //this function updates the value of the state inputValues
    const handleInputChange = (inputId, value) => {
        setInputValues((prevInputValues) => ({
            ...prevInputValues,
            [inputId]: value,
        }));
    };
    //this function processes form submission
    const handleSubmit = () => {
        // ... Your submit logic here
        props.onDataChange(inputValues)
    };
    //return child component
        return (
        <>
            <div id='OTPInputGroup' className="digitGroup" data-autosubmit="true">
                <OTPInput
                    id="input1"
                    value={inputValues.input1}
                    onValueChange={handleInputChange}
                    previousId={null}
                    handleSubmit={handleSubmit}
                    nextId="input2"
                />
                <OTPInput
                    id="input2"
                    value={inputValues.input2}
                    onValueChange={handleInputChange}
                    previousId="input1"
                    handleSubmit={handleSubmit}
                    nextId="input3"
                />
                <OTPInput
                    id="input3"
                    value={inputValues.input3}
                    onValueChange={handleInputChange}
                    previousId="input2"
                    handleSubmit={handleSubmit}
                    nextId="input4"
                />
               <OTPInput
                    id="input4"
                    value={inputValues.input4}
                    onValueChange={handleInputChange}
                    previousId="input3"
                    handleSubmit={handleSubmit}
                />
            </div>
            <style jsx="true">{`
            .digitGroup {
                display: flex;
                gap: 10px;
                justify-content: center;
                margin-bottom: 20px;
                }
                
                .digitGroup input {
                 outline: 0 !important;
                 user-select: none !important;
                 width: 50px;
                 height: 50px;
                 background-color: #C5DBF5;
                 font-weight: bold !important;
                 border-radius: 5px;
                 border: none;
                 line-height: 50px;
                 text-align: center;
                 font-size: 24px;
                 color: #001E9A;
                 margin: 0;
                }
                
                .digitGroup input:focus {
                 border: 2px solid #001E9A !important;
                }
                
                .digitGroup input:active {
                 border: 2px solid #001E9A !important;
                }
                
                .digitGroup .splitter {
                 padding: 5px 0;
                 color: rgb(0, 0, 0);
                 font-size: 25px;
                 margin: 0;
                }
                
                .prompt {
                 margin-bottom: 20px;
                 font-size: 20px;
                 color: white;
                }
                
                .formSection {
                 max-width: 500px;
                 margin: auto;
                 border-radius: 10px;
                 box-shadow: 0px 0px 8px #ddd;
                 padding: 20px;
                }
                
                .w-100 {
                 width: 100%;
                }
                
                /* Media query for mobile devices */
                @media (max-width: 480px) {
                 .digitGroup {
                  gap: 5px !important;
                 }
                 .digitGroup input {
                  width: 40px !important;
                 }
                 .digitGroup .splitter {
                  font-size: 25px !important;
                 }
                }
        `}
        </style>
        </>
    );
}

//Our child component
const OTPInput = ({ id, previousId, nextId, value, onValueChange, handleSubmit }) => {
    //This callback function only runs when a key is released
    const handleKeyUp = (e) => {
        //check if key is backspace or arrowleft
        if (e.keyCode === 8 || e.keyCode === 37) {
            //find the previous element
            const prev = document.getElementById(previousId);
            if (prev) {
                //select the previous element
                prev.select();
            }
        } else if (
            (e.keyCode >= 48 && e.keyCode <= 57) || //check if key is numeric keys 0 to 9
            (e.keyCode >= 65 && e.keyCode <= 90) || //check if key is alphabetical keys A to Z
            (e.keyCode >= 96 && e.keyCode <= 105) || //check if key is numeric keypad keys 0 to 9
            e.keyCode === 39 //check if key is right arrow key
        ) {
            //find the next element
            const next = document.getElementById(nextId);
            if (next) {
                //select the next element
                next.select();
            } else {
                //check if inputGroup has autoSubmit enabled
                const inputGroup = document.getElementById('OTPInputGroup');
                if (inputGroup && inputGroup.dataset['autosubmit']) {
                    //submit the form
                    handleSubmit();
                }
            }
        }
    }
    return (
        <>
        <input
            id={id}
            name={id}
            type="number"
            
            value={value}
            maxLength="1"
            onChange={(e) => onValueChange(id, e.target.value)}
            onKeyUp={handleKeyUp}
        />
        </>
    );
};

export default OTPInputGroup;